import React from 'react';
import { Grid2 as Grid, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import { CloseFormShowButton, EditFormShowButton, SaveFormShowButton, useFormShowContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';

interface RequiredPositionsSectionHeaderProps {
  onRequestVacancy: () => void;
}

const RequiredPositionsSectionHeader = ({ onRequestVacancy }: RequiredPositionsSectionHeaderProps) => {
  const { isEditMode } = useFormShowContext();

  return (
    <Grid
      container
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Grid size={3}>
        <Typography color="primary" variant="h4">
          Required positions
        </Typography>
      </Grid>
      <Grid size="grow" />
      <Grid size={2.2}>
        <Button variant="text" onClick={onRequestVacancy}>
          <Add sx={{ color: 'primary.main', fontSize: '12px' }} />
          <Typography color="primary" variant="subtitle1">
            Request Vacancy
          </Typography>
        </Button>
      </Grid>
      <Grid size="auto" display="flex" alignItems="center">
        {isEditMode ? (
          <>
            <SaveFormShowButton key="save" />
            <CloseFormShowButton key="close" />
          </>
        ) : (
          <EditFormShowButton key="edit" />
        )}
      </Grid>
    </Grid>
  );
};

export default RequiredPositionsSectionHeader;
